var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiAlertOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    var standardAlertStyles = {
        // Light theme has to subtract the borders
        padding: palette.type === "dark" ? spacing(3) : spacing(3) - 1,
        backgroundColor: palette.type === "dark"
            ? palette.background.paper
            : palette.background.default,
        border: palette.type === "dark" ? undefined : "1px solid ".concat(palette.divider),
        boxShadow: "none",
        "& $message": {
            minHeight: 40,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: spacing(0, 2),
        },
        "& $action": {
            color: palette.text.primary,
        },
    };
    return {
        root: {
            padding: spacing(2),
            boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.35)",
            alignItems: "flex-start",
        },
        icon: {
            padding: undefined,
            marginRight: undefined,
            opacity: undefined,
            minHeight: 40,
            minWidth: 40,
            justifyContent: "center",
            alignItems: "center",
        },
        message: {
            padding: spacing(2),
        },
        action: {
            marginRight: undefined,
            paddingLeft: spacing(4),
            minHeight: 40,
            minWidth: 60,
            justifyContent: "center",
        },
        filledSuccess: {
            fontWeight: undefined,
        },
        filledWarning: {
            fontWeight: undefined,
            color: palette.common.black,
        },
        filledError: {
            fontWeight: undefined,
        },
        standardInfo: __assign(__assign({}, standardAlertStyles), { color: palette.text.secondary, "& $icon": { color: palette.text.primary } }),
        standardSuccess: __assign(__assign({}, standardAlertStyles), { color: palette.type === "dark" ? palette.success.light : palette.success.main, "& $icon": {
                color: palette.success.main,
            } }),
        standardWarning: __assign(__assign({}, standardAlertStyles), { color: palette.type === "dark" ? palette.warning.light : palette.warning.main, "& $icon": {
                color: palette.warning.main,
            } }),
        standardError: __assign(__assign({}, standardAlertStyles), { color: palette.type === "dark" ? palette.error.light : palette.error.main, "& $icon": {
                color: palette.error.main,
            } }),
    };
};
//# sourceMappingURL=MuiAlert.js.map